import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function createSession() {
  const res = await axios.post(`${API}/sessions`);
  return res.data.session_id;
}

export async function fetchSessionMessages(sessionId) {
  const res = await axios.get(`${API}/messages/${sessionId}`);
  return (res.data.messages || []).map((m, i) => ({
    id: `hist-${i}-${m.timestamp}`,
    role: m.role,
    content: m.content,
  }));
}

export async function detectCollections(message, designSelected) {
  const res = await axios.post(`${API}/detect-collection`, { message, design_selected: designSelected });
  return res.data;
}

export async function fetchCollectionDesigns(collectionId) {
  const res = await axios.get(`${API}/collections/${collectionId}/designs`);
  return res.data.designs || [];
}

export async function sendChatMessage(sessionId, message) {
  const res = await axios.post(`${API}/chat`, { session_id: sessionId, message });
  return res.data;
}

export function sendChatMessageBackground(sessionId, message) {
  axios.post(`${API}/chat`, { session_id: sessionId, message }).catch(() => {});
}

export async function transcribeAudio(audioBlob) {
  const formData = new FormData();
  formData.append("file", audioBlob, "recording.webm");
  const res = await axios.post(`${API}/transcribe`, formData, { headers: { "Content-Type": "multipart/form-data" } });
  return res.data.text;
}

export async function uploadPaymentScreenshot(bookingId, file) {
  const formData = new FormData();
  formData.append("file", file);
  const res = await axios.post(`${API}/upload-payment-screenshot?booking_id=${bookingId}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
}
